import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { hasFlag, hasAnyFlag, hasAllFlags } from "./utils";
import NoPermission from "components/Platform/NoPermission";

const RoleBasedRoute = ({
  component: Component,
  requiredFlag,
  requiredFlags,
  requireAll,
  lenndFlags,
  router,
  redirectPath,
  showNoPermissionPage = true,
  ...rest
}) => {
  const checkAccess = () => {
    if (requiredFlags) {
      return requireAll
        ? hasAllFlags(lenndFlags, requiredFlags)
        : hasAnyFlag(lenndFlags, requiredFlags);
    }
    return hasFlag(lenndFlags, requiredFlag);
  };

  if (!checkAccess()) {
    if (showNoPermissionPage) {
      return <NoPermission returnPath={redirectPath} />;
    }
    router.push(redirectPath || "/home");
    return null;
  }

  return <Component {...rest} />;
};

RoleBasedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  requiredFlag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ NAME: PropTypes.string.isRequired })
  ]),
  requiredFlags: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ NAME: PropTypes.string.isRequired })
    ])
  ),
  requireAll: PropTypes.bool,
  lenndFlags: PropTypes.object,
  router: PropTypes.object.isRequired,
  redirectPath: PropTypes.string,
  showNoPermissionPage: PropTypes.bool
};

RoleBasedRoute.defaultProps = {
  requireAll: false,
  redirectPath: "/home",
  showNoPermissionPage: true
};

const mapStateToProps = state => ({
  lenndFlags: state.lenndFlags.flags
});

export default withRouter(connect(mapStateToProps)(RoleBasedRoute));
